import phoneImage from "../../assets/Nosotros.webp"

const AboutContent = () => (
  <div className="about-content-ini">
    <div className="about-image-container-ini">
      <div className="about-image-wrapper-ini">
        <img
          src={phoneImage || "/placeholder.svg"}
          alt="Equipo de Parking Club"
          className="about-image-ini"
          width="100%"
          height="auto"
          style={{ objectFit: "cover", aspectRatio: "4/3" }}
        />
      </div>
      <div className="about-image-bg-ini"></div>
    </div>
    <div className="about-text-ini">
      <h3 className="about-subtitle-ini">Nuestra misión</h3>
      <p className="about-paragraph-ini">
        Brindar a los propietarios de parqueaderos las herramientas tecnológicas necesarias para optimizar sus
        operaciones, maximizar sus ingresos y ofrecer una experiencia excepcional a sus clientes.
      </p>

      <h3 className="about-subtitle-ini">Nuestra historia</h3>
      <p className="about-paragraph-ini">
        Fundada en 2024 por un equipo de expertos en tecnología y gestión de estacionamientos, Parking Club nació de la
        necesidad de modernizar un sector tradicionalmente analógico. Hoy, nuestras soluciones están presentes en más de
        100 estacionamientos en todo el país.
      </p>

      <h3 className="about-subtitle-ini">Nuestros valores</h3>
      <ul className="values-list-ini">
        <li>
          <span className="dot-ini"></span> Innovación constante
        </li>
        <li>
          <span className="dot-ini"></span> Excelencia en el servicio al cliente
        </li>
        <li>
          <span className="dot-ini"></span> Compromiso con la eficiencia
        </li>
        <li>
          <span className="dot-ini"></span> Responsabilidad y transparencia
        </li>
      </ul>
    </div>
  </div>
)

export default function NosotrosSection() {
  return (
    <section className="about-section-ini">
      <div className="container-ini">
        <div className="section-header-ini">
          <h2 className="section-title-ini">Transformando la gestión de parqueaderos</h2>
          <p className="section-description-ini">
            En <span className="bold-ini">Parking Club</span>, nos dedicamos a desarrollar soluciones tecnológicas que
            revolucionan la forma en que se administran los estacionamientos.
          </p>
        </div>
        <AboutContent />
      </div>
    </section>
  )
}
